module.exports = __webpack_public_path__ + "img/404-ter.9cf0a1ad.png";